var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { ChangeDetectorRef } from '@angular/core';
import { FormBuilder, NgModel, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Modal } from '../../../../node_modules/ngx-modal';
import { environment } from '../../../environments/environment';
import { AccessLevel } from '../../common/enums/access-level.enum';
import { Permission } from '../../common/enums/permission.enum';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { UserRole } from '../../customerservice/constants/user-role.constants';
import { CacheService } from '../../shared/services/cache.service';
import { CommonService } from '../../shared/services/common.service';
import { DataShareService } from '../../shared/services/data.service';
import { MessageService } from '../../shared/services/message.service';
import { CommonMessage } from '../common/common-messages';
import { Constants, DefaultTicketType } from '../common/constants';
import { SearchRequestConstants } from '../common/search-request-constants';
import { OperatingCountryEnums } from '../enums/countries.enums';
import { Status } from '../enums/ticket-status.enum';
import { TicketType } from '../enums/ticket-type.enum';
import { PaginationReq } from '../interface/ticketingsystem/bulk-assign-tickets-req';
import { SearchModel } from '../interface/ticketingsystem/search.model';
import { ViewTabModel } from '../interface/ticketingsystem/view-tab-model';
import { DeleteModal } from '../models/delete-modal';
import { TicketTabInfo } from '../models/tickets-tab.model';
import { CustomerService } from '../services/customer.service';
import { DepartmentService } from './../services/department.service';
import { NotificationType } from '../enums/notification-types.enum';
var MyTeamTicketsComponent = /** @class */ (function () {
    function MyTeamTicketsComponent(_cacheService, _dataShareService, _commonService, departmentService, _customerservice, _formbuilder, _translatePipe, messageService, chRef) {
        this._cacheService = _cacheService;
        this._dataShareService = _dataShareService;
        this._commonService = _commonService;
        this.departmentService = departmentService;
        this._customerservice = _customerservice;
        this._formbuilder = _formbuilder;
        this._translatePipe = _translatePipe;
        this.messageService = messageService;
        this.chRef = chRef;
        this.rightContentWidth = 1000;
        this.active = true;
        this.tabs = new Array();
        this.existedValues = new Array();
        this.justifyingTabs = false;
        this.myTickets = new Array();
        this.allTickets = new Array();
        this.showAllTickets = true;
        this.ticketTypeOnSelectAll = true;
        this.departmentOnSelectAll = true;
        this.assignToOnSelectAll = true;
        this.sourceOnSelectAll = true;
        this.statusOnSelectAll = true;
        this.subTypeOnSelectAll = true;
        this.priorityOnSelectAll = true;
        this.disputeReasonOnSelectAll = true;
        this.isClearClicked = false;
        this.createdByOnSelectAll = true;
        this.pageNumber = 1;
        this.pageSize = 25;
        this.pageCount = 0;
        this.isDesc = true;
        this.pageSizes = [10, 25, 50, 75];
        this.sortColumn = 'TICKET_NUMBER';
        this.sort = 'DESC';
        this.excelIconUrl = environment.cdnURL + '/flpi/images/ms_excel.ico';
        this.disputeSearch = false;
        this.selectedTickets = new Array();
        this.selectAll = false;
        this.ticketsOnSelectAll = new Array();
        this.message = '';
        this.closed = 0;
        /**
         * Pagination instance - to avoid console warnings - inorder to assign id for pagination
         */
        this.paginationInstance = {
            id: 'my-team-tickets-pagination',
            itemsPerPage: 10,
            currentPage: 1
        };
        this.dropdownSettings = {
            sourceDropdownList: [],
            sourceSelectedItems: [],
            sourceIndex: 1,
            typeDropdownList: [],
            typeSelectedItems: [],
            typeIndex: 2,
            subTypeDropdownList: [],
            subTypeSelectedItems: [],
            subTypeIndex: 3,
            statusDropdownList: [],
            statusSelectedItems: [],
            statusIndex: 4,
            priorityDropdownList: [],
            prioritySelectedItems: [],
            priorityIndex: 5,
            departmentDropdownList: [],
            departmentSelectedItems: [],
            departmentIndex: 6,
            assignedToDropdownList: [],
            assignedToSelectedItems: [],
            assignedToIndex: 7,
            createdByDropdownList: [],
            createdBySelectedItems: [],
            createdByIndex: 8,
            disputeReasonDropdownList: [],
            disputeReasonSelectedItem: [],
            disputeReasonIndex: 9,
            settings: {},
        };
    }
    MyTeamTicketsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.buildForm();
        this.buildSpamForm();
        this.intializeMultiselectDropdowns();
        this.dropdownSettings.settings = {
            singleSelection: false,
            text: 'select..',
            selectAllText: 'Select All',
            unSelectAllText: 'Select All',
            enableSearchFilter: false,
            classes: 'myclass custom-class',
            badgeShowLimit: 1
        };
        this.tabModel = new ViewTabModel();
        this.fieldTypes = new SearchRequestConstants();
        this.subscribeTabContent();
        this.subscribeClosedTabs();
        this.userInfo = this._cacheService.get(CacheKey.UserInfo);
        this.isTicketView = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.MANAGE_TICKETS_VIEW + ']'), AccessLevel.Customer_Service);
        this.assignedToId = this.userInfo.userId;
        this.active = false;
        this.activetab = 1;
        this.overDueDisable = false;
        this.ticketSearchModel = new SearchModel;
        this.countryId = this.getAllowedCountries();
        this.getOperatingCountries();
        this.ticketSearchModel.overDueCount = false;
        this.showAllTickets = true;
        this.getTicketTypesAndSubTypes();
        if (this.userInfo.privileges.departments && !this.userInfo.hasSystemRole) {
            this.userDepartments = this.userInfo.privileges.departments.map(function (a) { return a.id; });
        }
        this.getDepartments();
        this.getTicketStatus();
        this.showAllTickets = false;
        this.getSourceTypes();
        this.getTicketPriorities();
        this._dataShareService.customerServiceMessage.subscribe(function (message) {
            if (message && message !== '') {
                var splittedMessage = message.split('-');
                _this.rightContentWidth = parseInt(splittedMessage[0]);
            }
        });
        this.deleteModal = new DeleteModal(this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this));
        this.deleteModal.viewActionButtons = false;
        this.isDiputeTicketSearch ? this.disputeSearch = true : '';
        this.closed = Status.Closed;
    };
    MyTeamTicketsComponent.prototype.selectTab = function (tab) {
        this.activetab = tab;
    };
    MyTeamTicketsComponent.prototype.changeTab = function (tab) {
        this.activetab = tab;
    };
    MyTeamTicketsComponent.prototype.doNotRemoveFormData = function () {
        //data should not be removed...
    };
    MyTeamTicketsComponent.prototype.subscribeTabContent = function () {
        var _this = this;
        this.messageService.getCustomerServiceTabContent().subscribe(function (data) {
            if (data) {
                _this.id = data.id;
                _this.tabTitle = data.tabName;
                _this.componentName = data.componentName;
                _this.addNewTab();
                _this.justifyingTabs = (_this.tabs && _this.tabs.length) ? true : false;
                // observable event to display close all open tabs link in ui in search screen (For SearchComponent)
                _this.messageService.setOpenTabsInfo((_this.tabs && _this.tabs.length) ? true : false);
            }
        });
    };
    /**
      * To get Tabs information (AS of now-- true / false) -- True refers there are opened tabs
  */
    MyTeamTicketsComponent.prototype.subscribeClosedTabs = function () {
        var _this = this;
        this.messageService.getCloseTabsEvent().subscribe(function (data) {
            if (data) {
                _this.closeAllOpenedTabs();
            }
        });
    };
    MyTeamTicketsComponent.prototype.addNewTab = function () {
        var newTabIndex = this.tabs.length + 1;
        this.tabModel = new ViewTabModel();
        this.tabModel.id = this.id;
        this.tabModel.title = this.tabTitle;
        this.tabModel.disabled = false;
        this.tabModel.removable = true;
        this.tabModel.active = true;
        this.tabModel.componentName = this.componentName;
        this.existedValues = new Array();
        var index = this.tabs.map(function (el) {
            return el.id;
        }).indexOf(this.id);
        if (this.tabs.length === Constants.MaximumTabsLength) {
            this.displayAlertBoxOnReachingMaxTabs();
        }
        else {
            if (index < 0) {
                this.tabs.push(this.tabModel);
            }
            else {
                var selectedId_1 = this.id;
                this.tabs.forEach(function (x) {
                    if (x.id !== selectedId_1) {
                        x.active = false;
                    }
                    else {
                        x.active = true;
                    }
                });
            }
        }
    };
    /**
     * removes tab at specific index
     * @param tab
     */
    MyTeamTicketsComponent.prototype.removeTabHandler = function (tab) {
        if (this.tabs) {
            this.tabs.splice(this.tabs.indexOf(tab), 1);
            this.justifyingTabs = (this.tabs && this.tabs.length) ? true : false;
            this._dataShareService.changeCloseAllTabsMessage((this.justifyingTabs ? 1 : 0) + '- tabs');
        }
    };
    /**
     * Close all opened tabs
     */
    MyTeamTicketsComponent.prototype.closeAllOpenedTabs = function () {
        this.tabs = []; //new Array<DynamicTabModel>();
        this.justifyingTabs = (this.tabs && this.tabs.length) ? true : false;
        this._dataShareService.changeCloseAllTabsMessage((this.justifyingTabs ? 1 : 0) + '- tabs');
    };
    /**
     * display alert box on reaching maximum no of tabs = 8
     */
    MyTeamTicketsComponent.prototype.displayAlertBoxOnReachingMaxTabs = function () {
        this.deleteModal.toggle = true;
        this.deleteModal.message = CommonMessage.tabsMessage;
    };
    MyTeamTicketsComponent.prototype.openDropDown = function (element) {
        var elem = document.getElementById(element);
        var dropDownList = elem.children[0].children[1];
        dropDownList.removeAttribute('hidden');
    };
    MyTeamTicketsComponent.prototype.onDropDowneBlur = function (element) {
        var elem = document.getElementById(element);
        var dropDownList = elem.children[0].children[1];
        dropDownList.setAttribute('hidden', 'true');
    };
    MyTeamTicketsComponent.prototype.getEditPermission = function (departmentId) {
        if (departmentId) {
            var isView = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + Permission.MANAGE_DEPARTMENT_TICKETS_EDIT + ']'), AccessLevel.Department, departmentId);
            return isView;
        }
        else {
            return false;
        }
    };
    /**
    * display alert box if the logged in user do not have permission to see the fbo/retail information
    */
    MyTeamTicketsComponent.prototype.displayAlertbox = function () {
        this.deleteModal.toggle = true;
        this.deleteModal.message = CommonMessage.noPermissionMessage;
    };
    /**
     * @description To Search Tickets
     * @date 2020-01-31
     * @param {boolean} [tabChange]
     * @memberof MyTeamTicketsComponent
     */
    MyTeamTicketsComponent.prototype.onSearch = function (tabChange) {
        var searchBtn = document.getElementById('search-button');
        if (searchBtn) {
            searchBtn.classList.add('button-active');
            setTimeout(function () {
                searchBtn.classList.remove('button-active');
            }, 1000);
        }
        if (!tabChange) {
            this.pageNumber = 1;
        }
        else {
            this.pageNumber = isNaN(this.pageNumber) ? 1 : this.pageNumber;
        }
        this.getTicketsSearch(true);
    };
    /**
     * search with ticket number
     */
    MyTeamTicketsComponent.prototype.searchWithTicketNumber = function () {
        if (this.ticketSearchModel.ticketNumber || this.ticketSearchModel.email) {
            this.dropdownSettings.settings = __assign({}, this.dropdownSettings.settings, { disabled: true });
            this.chRef.detectChanges();
            this.overDueDisable = true;
            this.OnTabSearchFocus();
            this.dropdownSettings.statusSelectedItems = this.dropdownSettings.statusDropdownList;
        }
        else {
            this.dropdownSettings.settings = __assign({}, this.dropdownSettings.settings, { disabled: false });
            this.chRef.detectChanges();
            this.overDueDisable = false;
        }
    };
    MyTeamTicketsComponent.prototype.getDepartments = function () {
        var _this = this;
        this._customerservice.getAllDepartmentsByOperatingCountryId(this.countryId).subscribe(function (response) {
            if (response) {
                _this.departments = response;
                _this.departments.sort(function (item1, item2) {
                    var dept1 = item1.value.toLowerCase(), dept2 = item2.value.toLowerCase();
                    if (dept1 < dept2) {
                        return -1;
                    }
                    if (dept1 > dept2) {
                        return 1;
                    }
                    return 0;
                });
                if (!_this.userInfo.hasSystemRole) {
                    if (_this.userInfo.privileges.departments && _this.userInfo.privileges.departments.length > 0) {
                        var departmentIds = _this.userInfo.privileges.departments.map(function (a) { return a.id; });
                    }
                }
                _this.departments.forEach(function (item) {
                    _this.dropdownSettings.departmentDropdownList.push({ id: item.id, itemName: item.value });
                });
                _this.dropdownSettings.departmentSelectedItems = JSON.parse(JSON.stringify(_this.dropdownSettings.departmentDropdownList));
                _this.bulkAssignDepts = _this.dropdownSettings.departmentSelectedItems;
                if (_this.dropdownSettings.departmentSelectedItems && _this.dropdownSettings.departmentSelectedItems.length > 0) {
                    _this.getAssignedUsersByDepartments(_this.dropdownSettings.departmentSelectedItems.map(function (item) { return item.id; }), true);
                }
                _this.setFocusToTextBox();
            }
        });
    };
    MyTeamTicketsComponent.prototype.getAssignedUsersByDepartments = function (departmentIds, onLoad) {
        var _this = this;
        if (departmentIds) {
            this.dropdownSettings.assignedToDropdownList = [];
            this.dropdownSettings.assignedToSelectedItems = [];
            this.dropdownSettings.createdByDropdownList = [];
            this.dropdownSettings.createdBySelectedItems = [];
            this._customerservice.getAssignedUsersByDepartmentIds(departmentIds).subscribe(function (response) {
                if (response) {
                    _this.users = response;
                    _this.users.forEach(function (item) {
                        _this.dropdownSettings.assignedToDropdownList.push({ id: item.id, itemName: item.name.trim() });
                        _this.dropdownSettings.createdByDropdownList.push({ id: item.id, itemName: item.name.trim() });
                    });
                    if (_this.dropdownSettings != null) {
                        if (_this.dropdownSettings.assignedToDropdownList != null && !_this.dropdownSettings.assignedToDropdownList.find(function (user) { return user.id === 1; })) {
                            _this.dropdownSettings.assignedToDropdownList.push({ id: 1, itemName: UserRole.SuperAdministrator });
                        }
                        if (_this.dropdownSettings.createdByDropdownList != null && !_this.dropdownSettings.createdByDropdownList.find(function (user) { return user.id === 1; })) {
                            _this.dropdownSettings.createdByDropdownList.push({ id: 1, itemName: UserRole.SuperAdministrator });
                        }
                    }
                    _this.dropdownSettings.assignedToDropdownList.sort(function (item1, item2) {
                        var tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase();
                        if (tickettype1 < tickettype2) {
                            return -1;
                        }
                        if (tickettype1 > tickettype2) {
                            return 1;
                        }
                        return 0;
                    });
                    _this.dropdownSettings.createdByDropdownList.sort(function (item1, item2) {
                        var tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase();
                        if (tickettype1 < tickettype2) {
                            return -1;
                        }
                        if (tickettype1 > tickettype2) {
                            return 1;
                        }
                        return 0;
                    });
                    if (onLoad) {
                        _this.dropdownSettings.assignedToSelectedItems = JSON.parse(JSON.stringify(_this.dropdownSettings.assignedToDropdownList));
                        _this.dropdownSettings.createdBySelectedItems = JSON.parse(JSON.stringify(_this.dropdownSettings.createdByDropdownList));
                    }
                    if (_this.isClearClicked) {
                        _this.onSearch();
                        _this.isClearClicked = false;
                    }
                }
                else {
                    _this.users = [];
                    _this.dropdownSettings.assignedToDropdownList = [];
                    _this.dropdownSettings.assignedToSelectedItems = [];
                    _this.dropdownSettings.createdByDropdownList = [];
                    _this.dropdownSettings.createdBySelectedItems = [];
                }
            });
        }
    };
    MyTeamTicketsComponent.prototype.resetBulkAssigForm = function () {
        this.ticketAssignForm.reset();
        this.ticketAssignForm.controls['statusId'].setValue('');
        this.ticketAssignForm.controls['departmentId'].setValue('');
        this.ticketAssignForm.controls['assignToId'].setValue(''), Validators.required;
        this.isFormInvalid = false;
        this.isSubmitted = false;
        this.bulkTicketAssignees = [];
        this.selectedTickets = [];
    };
    MyTeamTicketsComponent.prototype.resetTicketSpamOrUnspamForm = function () {
        this.ticketSpamOrUnspamForm.reset();
        this.isFormInvalid = false;
        this.selectedTickets = [];
        this.ticketSpamOrUnspamForm.controls['ticketId'].setValue(''), Validators.required;
    };
    /*
   form data to download to pdf/ csv/print
   */
    MyTeamTicketsComponent.prototype.Download = function (type) {
        var _this = this;
        var columns = [
            this._translatePipe.get('ticketing-system.Priority')['value'],
            this._translatePipe.get('ticketing-system.Ticket#')['value'],
            this._translatePipe.get('ticketing-system.Assigned to User')['value'],
            this._translatePipe.get('ticketing-system.Subject')['value'],
            this._translatePipe.get('ticketing-system.Ticket Subtype')['value'],
            this._translatePipe.get('ticketing-system.Dispute Reason')['value'],
            this._translatePipe.get('ticketing-system.Status')['value'],
            this._translatePipe.get('ticketing-system.Due Date')['value'],
            this._translatePipe.get('ticketing-system.Created Date')['value'],
            this._translatePipe.get('ticketing-system.Created By')['value'],
            this._translatePipe.get('ticketing-system.Last Modified Date')['value']
        ];
        var rowdata = new Array();
        var finalrows = new Array();
        this._customerservice.SearchTicketsOnPagination(null, (this.dropdownSettings.assignedToSelectedItems && this.dropdownSettings.assignedToSelectedItems.length > 0 && !(this.ticketSearchModel.ticketNumber || this.ticketSearchModel.email) ? this.dropdownSettings.assignedToSelectedItems.map(function (item) { return item.id; }) : []), this.ticketSearchModel.ticketNumber, (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0 && !(this.ticketSearchModel.ticketNumber || this.ticketSearchModel.email) ? this.dropdownSettings.typeSelectedItems.map(function (item) { return item.id; }) : []), (this.dropdownSettings.subTypeSelectedItems && this.dropdownSettings.subTypeSelectedItems.length > 0 && !(this.ticketSearchModel.ticketNumber || this.ticketSearchModel.email) ? this.dropdownSettings.subTypeSelectedItems.map(function (item) { return item.id; }) : []), (this.dropdownSettings.sourceSelectedItems && this.dropdownSettings.sourceSelectedItems.length > 0 && !(this.ticketSearchModel.ticketNumber || this.ticketSearchModel.email) ? this.dropdownSettings.sourceSelectedItems.map(function (item) { return item.id; }) : []), (this.dropdownSettings.departmentSelectedItems && this.dropdownSettings.departmentSelectedItems.length > 0 && !(this.ticketSearchModel.ticketNumber || this.ticketSearchModel.email) ? this.dropdownSettings.departmentSelectedItems.map(function (item) { return item.id; }) : []), (this.dropdownSettings.statusSelectedItems.map(function (item) { return item.id; })), (this.dropdownSettings.prioritySelectedItems && this.dropdownSettings.prioritySelectedItems.length > 0 ? this.dropdownSettings.prioritySelectedItems.map(function (item) { return item.id; }) : []), this.pageNumber, this.pageSize, this.sortColumn, this.sort, null, this.disputeSearch, this.ticketSearchModel.overDueCount, !(this.ticketSearchModel.ticketNumber || this.ticketSearchModel.email) ? this.unAssinged : null, this.ticketSearchModel.email ? this.ticketSearchModel.email : null, this.ticketSearchModel.email ? this.countryId : null, (this.dropdownSettings.createdBySelectedItems && this.dropdownSettings.createdBySelectedItems.length > 0 ? this.dropdownSettings.createdBySelectedItems.map(function (item) { return item.id; }) : []), (this.dropdownSettings.disputeReasonSelectedItem && this.dropdownSettings.disputeReasonSelectedItem.length > 0 ? this.dropdownSettings.disputeReasonSelectedItem.map(function (item) { return item.id; }) : []), true).subscribe(function (response) {
            if (response && response['content']) {
                var tickets = response['content'];
                for (var i = 0; i < tickets.length; i++) {
                    rowdata = [];
                    var a1 = tickets[i];
                    rowdata.push(a1.priorityValue);
                    rowdata.push('\t' + a1.ticketNumber);
                    rowdata.push(a1.assignedToValue ? a1.assignedToValue : '');
                    rowdata.push(a1.subject);
                    rowdata.push(a1.subType);
                    rowdata.push(a1.disputeReasonName ? a1.disputeReasonName : '');
                    rowdata.push(a1.status);
                    rowdata.push(a1.dueDate ? moment.utc(a1.dueDate).utcOffset(0).format('DD-MMM-YYYY') : '');
                    rowdata.push(a1.createdDate ? moment.utc(a1.createdDate).utcOffset(0).format('DD-MMM-YYYY') : '');
                    rowdata.push(a1.createdByName ? a1.createdByName : '');
                    rowdata.push(a1.modifiedDate ? moment.utc(a1.modifiedDate).utcOffset(0).format('DD-MMM-YYYY') : '');
                    finalrows.push(rowdata);
                }
            }
            var title = _this._translatePipe.get('ticketing-system.My Team Tickets')['value'];
            _this._customerservice.ExcelDownload(columns, finalrows, 'My Team Tickets', title);
        });
    };
    MyTeamTicketsComponent.prototype.getTicketsSearch = function (isClearSelectedItems) {
        var _this = this;
        if (this.email.control.status.toLocaleUpperCase() == Constants.VALID.toLocaleUpperCase() && !(this.ticketSearchModel.ticketNumber && this.ticketSearchModel.email)) {
            if (isClearSelectedItems) {
                this.selectAll = false;
                this.selectedTickets = [];
            }
            if (this.isBulkAssignSearch) {
                this.resetBulkAssigForm();
                this.isBulkAssignSearch = false;
            }
            if (this.isAllSelectedTicketsSpamedOrUnspamed) {
                this.resetTicketSpamOrUnspamForm();
                this.isAllSelectedTicketsSpamedOrUnspamed = false;
            }
            if (!(this.dropdownSettings.statusSelectedItems && this.dropdownSettings.statusSelectedItems.length > 0)) {
                this.dropdownSettings.statusSelectedItems.push({ id: Status.InProgress, itemName: Status[Status.InProgress] });
                this.statusOnSelectAll = false;
            }
            this._customerservice.SearchTicketsOnPagination(null, (this.dropdownSettings.assignedToSelectedItems && this.dropdownSettings.assignedToSelectedItems.length > 0 && !(this.ticketSearchModel.ticketNumber || this.ticketSearchModel.email) ? this.dropdownSettings.assignedToSelectedItems.map(function (item) { return item.id; }) : []), this.ticketSearchModel.ticketNumber, (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0 && !(this.ticketSearchModel.ticketNumber || this.ticketSearchModel.email) ? this.dropdownSettings.typeSelectedItems.map(function (item) { return item.id; }) : []), (this.dropdownSettings.subTypeSelectedItems && this.dropdownSettings.subTypeSelectedItems.length > 0 && !(this.ticketSearchModel.ticketNumber || this.ticketSearchModel.email) ? this.dropdownSettings.subTypeSelectedItems.map(function (item) { return item.id; }) : []), (this.dropdownSettings.sourceSelectedItems && this.dropdownSettings.sourceSelectedItems.length > 0 && !(this.ticketSearchModel.ticketNumber || this.ticketSearchModel.email) ? this.dropdownSettings.sourceSelectedItems.map(function (item) { return item.id; }) : []), (this.dropdownSettings.departmentSelectedItems && this.dropdownSettings.departmentSelectedItems.length > 0 && !(this.ticketSearchModel.ticketNumber || this.ticketSearchModel.email) ? this.dropdownSettings.departmentSelectedItems.map(function (item) { return item.id; }) : []), (this.dropdownSettings.statusSelectedItems.map(function (item) { return item.id; })), (this.dropdownSettings.prioritySelectedItems && this.dropdownSettings.prioritySelectedItems.length > 0 ? this.dropdownSettings.prioritySelectedItems.map(function (item) { return item.id; }) : []), this.pageNumber, this.pageSize, this.sortColumn, this.sort, null, this.disputeSearch, this.ticketSearchModel.overDueCount, !(this.ticketSearchModel.ticketNumber || this.ticketSearchModel.email) ? this.unAssinged : null, this.ticketSearchModel.email ? this.ticketSearchModel.email : null, this.ticketSearchModel.email ? this.countryId : null, (this.dropdownSettings.createdBySelectedItems && this.dropdownSettings.createdBySelectedItems.length > 0 ? this.dropdownSettings.createdBySelectedItems.map(function (item) { return item.id; }) : []), (this.dropdownSettings.disputeReasonSelectedItem && this.dropdownSettings.disputeReasonSelectedItem.length > 0 ? this.dropdownSettings.disputeReasonSelectedItem.map(function (item) { return item.id; }) : []), false).subscribe(function (response) {
                if (response) {
                    _this.pageCount = response['totalCount'];
                    _this.allTickets = response['content'];
                    _this.myTickets = response['content'];
                    if (_this.allTickets && _this.allTickets.length) {
                        _this.allTickets.forEach(function (x) {
                            if (x.dueDate) {
                                x.dueDate = moment.utc(x.dueDate)
                                    .utcOffset(0).format('DD-MMM-YYYY');
                            }
                            if (x.createdDate) {
                                x.createdDate = moment.utc(x.createdDate)
                                    .utcOffset(0).format('DD-MMM-YYYY');
                            }
                            if (x.modifiedDate) {
                                x.modifiedDate = moment.utc(x.modifiedDate)
                                    .utcOffset(0).format('DD-MMM-YYYY');
                            }
                            if (_this.selectedTickets.find(function (ticket) { return ticket.id === x.id; })) {
                                x.isSelected = true;
                            }
                        });
                        _this.selectAll = _this.myTickets.every(function (ticket) { return ticket.isSelected === true; });
                    }
                }
                else {
                    _this.pageCount = 0;
                    _this.myTickets = [];
                    _this.allTickets = [];
                }
                _this.getAssignToUsersByDepartments(_this.dropdownSettings.departmentSelectedItems.map(function (item) { return item.id; }));
                _this.setFocusToTextBox();
            });
        }
    };
    MyTeamTicketsComponent.prototype.getTicketTypes = function () {
        var _this = this;
        this._customerservice.getTicketTypes().subscribe(function (response) {
            if (response) {
                _this.ticketTypes = response;
                _this.ticketTypes.sort(function (item1, item2) {
                    var tickettype1 = item1.value.toLowerCase(), tickettype2 = item2.value.toLowerCase();
                    if (tickettype1 < tickettype2) {
                        return -1;
                    }
                    if (tickettype1 > tickettype2) {
                        return 1;
                    }
                    return 0;
                });
            }
        });
    };
    MyTeamTicketsComponent.prototype.subTypesSort = function () {
        this.dropdownSettings.subTypeDropdownList.sort(function (item1, item2) {
            var tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase();
            if (tickettype1 < tickettype2) {
                return -1;
            }
            if (tickettype1 > tickettype2) {
                return 1;
            }
            return 0;
        });
    };
    MyTeamTicketsComponent.prototype.ticketTypesSort = function () {
        this.dropdownSettings.typeDropdownList.sort(function (item1, item2) {
            var tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase();
            if (tickettype1 < tickettype2) {
                return -1;
            }
            if (tickettype1 > tickettype2) {
                return 1;
            }
            return 0;
        });
    };
    MyTeamTicketsComponent.prototype.getTicketTypesAndSubTypes = function () {
        var _this = this;
        this.departmentService.getTicketTypesAndSubTypes(this.countryId).subscribe(function (response) {
            if (response && !_this.isDiputeTicketSearch) {
                _this.ticketTypes = response;
                _this.ticketTypes.forEach(function (item) {
                    var operatingCountryName;
                    if (item.operatingCountryName !== null) {
                        operatingCountryName = item.operatingCountryName.trim();
                    }
                    else if (item.operatingCountryName === null && (item.value == DefaultTicketType.Orders || item.value == DefaultTicketType.Products)) {
                        operatingCountryName = 'ALL';
                    }
                    var ticketType = operatingCountryName + ' ' + '-' + ' ' + item.value.trim();
                    _this.dropdownSettings.typeDropdownList.push({ id: item.id, itemName: ticketType });
                    if (item.value.trim().includes('FLP360')) {
                        item.subTypes.forEach(function (subType) {
                            var subTypeName = subType.name.trim() + '(' + item.value.trim() + ')';
                            _this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subTypeName });
                        });
                    }
                    else {
                        item.subTypes.forEach(function (subType) {
                            _this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subType.name.trim() });
                        });
                    }
                    _this.dropdownSettings.subTypeSelectedItems = JSON.parse(JSON.stringify(_this.dropdownSettings.subTypeDropdownList));
                    if (item.value.trim() === TicketType.Order) {
                        _this.getDisputeReasons();
                    }
                });
                _this.dropdownSettings.typeDropdownList.sort(function (item1, item2) {
                    var tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase();
                    if (tickettype1 < tickettype2) {
                        return -1;
                    }
                    if (tickettype1 > tickettype2) {
                        return 1;
                    }
                    return 0;
                });
                _this.dropdownSettings.subTypeDropdownList.sort(function (item1, item2) {
                    var tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase();
                    if (tickettype1 < tickettype2) {
                        return -1;
                    }
                    if (tickettype1 > tickettype2) {
                        return 1;
                    }
                    return 0;
                });
                _this.dropdownSettings.typeSelectedItems = JSON.parse(JSON.stringify(_this.dropdownSettings.typeDropdownList));
            }
            else if (response && _this.isDiputeTicketSearch) {
                _this.ticketTypes = response.filter(function (type) { return type.value === TicketType.Order; });
                _this.ticketTypes.forEach(function (item) {
                    _this.dropdownSettings.typeDropdownList.push({ id: item.id, itemName: item.value.trim() });
                    _this.dropdownSettings.typeSelectedItems.push({ id: item.id, itemName: item.value.trim() });
                });
                var selectedIds_1 = _this.dropdownSettings.typeSelectedItems.map(function (index) { return index.id; });
                _this.dropdownSettings.subTypeDropdownList = [];
                _this.dropdownSettings.subTypeSelectedItems = [];
                _this.ticketTypes.filter(function (item) { return selectedIds_1.some(function (index) { return index === item.id; }); }).forEach(function (type) {
                    if (type.value.trim().includes('FLP360')) {
                        type.subTypes.forEach(function (subType) {
                            var subTypeName = subType.name.trim() + '(' + type.value.trim() + ')';
                            _this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subTypeName });
                            _this.dropdownSettings.subTypeSelectedItems.push({ id: subType.id, itemName: subTypeName });
                        });
                    }
                    else {
                        type.subTypes.forEach(function (subType) {
                            _this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subType.name.trim() });
                            _this.dropdownSettings.subTypeSelectedItems.push({ id: subType.id, itemName: subType.name.trim() });
                        });
                    }
                });
                _this.dropdownSettings.typeSelectedItems = JSON.parse(JSON.stringify(_this.dropdownSettings.typeDropdownList));
            }
        });
    };
    MyTeamTicketsComponent.prototype.getSourceTypes = function () {
        var _this = this;
        if (this.sourceTypes) {
            this.sourceTypes.forEach(function (item) {
                _this.dropdownSettings.sourceDropdownList.push({ id: item.id, itemName: item.value });
            });
            this.dropdownSettings.sourceSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.sourceDropdownList));
        }
    };
    MyTeamTicketsComponent.prototype.getTicketPriorities = function () {
        var _this = this;
        if (this.ticketPriorities) {
            this.ticketPriorities.forEach(function (item) {
                _this.dropdownSettings.priorityDropdownList.push({ id: item.id, itemName: item.value });
            });
            this.dropdownSettings.prioritySelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.priorityDropdownList));
        }
    };
    MyTeamTicketsComponent.prototype.getTicketStatus = function () {
        var _this = this;
        if (this.statusTypes) {
            this.dropdownSettings.statusSelectedItems = [];
            this.statusTypes.forEach(function (item) {
                _this.dropdownSettings.statusDropdownList.push({ id: item.id, itemName: item.value });
                if (item.id === Status.InProgress || item.id === Status.New
                    || item.id === Status.OnHold) {
                    _this.dropdownSettings.statusSelectedItems.push({ id: item.id, itemName: item.value });
                    _this.statusOnSelectAll = false;
                }
            });
            this.bulkAssignStatus = this.dropdownSettings.statusSelectedItems;
        }
    };
    /**
     * sort table by respective column
     * @param sortColumn
     */
    MyTeamTicketsComponent.prototype.sortTableByColumn = function (sortColumn) {
        this.isDesc = (this.sortColumn == sortColumn) ? !this.isDesc : this.isDesc;
        this.sort = this.isDesc ? 'DESC' : 'ASC';
        this.sortColumn = sortColumn;
        //added this condition not to hit service if there are no items in grid.
        if (this.myTickets.length === 0) {
            return;
        }
        if (this.isBulkAssignSearch === true) {
            this.getBulkAssignTickets();
            return;
        }
        this.getTicketsSearch();
    };
    /**
       * On Page change
       * @param pageNumber
       */
    MyTeamTicketsComponent.prototype.pageChange = function (pageNumber) {
        if (!isNaN(pageNumber)) {
            if (this.isBulkAssignSearch) {
                this.bulkAssignReq.pageNumber = pageNumber;
                this.getBulkAssignTickets();
            }
            else {
                this.pageNumber = pageNumber;
                this.getTicketsSearch();
            }
        }
    };
    MyTeamTicketsComponent.prototype.onItemSelect = function (item, indexValue) {
        var _this = this;
        if (this.dropdownSettings.departmentIndex === +indexValue) {
            if (this.dropdownSettings.departmentSelectedItems && this.dropdownSettings.departmentSelectedItems.length > 0) {
                this.bulkAssignDepts = this.dropdownSettings.departmentSelectedItems;
                this.departmentOnSelectAll = false;
                if (this.departments.length === this.dropdownSettings.departmentSelectedItems.length) {
                    this.departmentOnSelectAll = true;
                }
            }
            else {
                this.departments.forEach(function (item) {
                    _this.dropdownSettings.departmentDropdownList.push({ id: item.id, itemName: item.value.trim() });
                });
            }
            if (this.dropdownSettings.departmentSelectedItems && this.dropdownSettings.departmentSelectedItems.length > 0) {
                var deptIds = this.dropdownSettings.departmentSelectedItems.map(function (item) { return item.id; });
                this.getAssignedUsersByDepartments(deptIds);
                this.ticketAssignForm.controls['departmentId'].patchValue(deptIds);
            }
            else {
                this.dropdownSettings.assignedToDropdownList = [];
                this.dropdownSettings.assignedToSelectedItems = [];
                this.dropdownSettings.createdByDropdownList = [];
                this.dropdownSettings.createdBySelectedItems = [];
                this.ticketAssignForm.controls['departmentId'].setValue('');
            }
        }
        else if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = false;
            if (this.statusTypes.length === this.dropdownSettings.statusSelectedItems.length) {
                this.statusOnSelectAll = true;
            }
        }
        else if (this.dropdownSettings.sourceIndex === +indexValue) {
            this.sourceOnSelectAll = false;
            if (this.sourceTypes.length === this.dropdownSettings.sourceSelectedItems.length) {
                this.sourceOnSelectAll = true;
            }
        }
        else if (this.dropdownSettings.subTypeIndex === +indexValue) {
            this.subTypeOnSelectAll = false;
            if (this.dropdownSettings.subTypeDropdownList.length === this.dropdownSettings.subTypeSelectedItems.length) {
                this.subTypeOnSelectAll = true;
            }
        }
        else if (this.dropdownSettings.departmentIndex === +indexValue) {
            this.departmentOnSelectAll = false;
            if (this.departments.length === this.dropdownSettings.departmentSelectedItems.length) {
                this.departmentOnSelectAll = true;
            }
        }
        else if (this.dropdownSettings.assignedToIndex === +indexValue) {
            this.assignToOnSelectAll = false;
            this.unAssinged = false;
            if (this.users.length === this.dropdownSettings.assignedToSelectedItems.length) {
                this.assignToOnSelectAll = true;
                this.unAssinged = true;
            }
        }
        else if (this.dropdownSettings.priorityIndex === +indexValue) {
            this.priorityOnSelectAll = false;
            if (this.ticketPriorities.length === this.dropdownSettings.prioritySelectedItems.length) {
                this.priorityOnSelectAll = true;
            }
        }
        else if (this.dropdownSettings.createdByIndex === +indexValue) {
            this.createdByOnSelectAll = false;
            this.unAssinged = false;
            if (this.users.length === this.dropdownSettings.createdBySelectedItems.length) {
                this.createdByOnSelectAll = true;
                this.unAssinged = true;
            }
        }
        else if (this.dropdownSettings.disputeReasonIndex === +indexValue) {
            this.disputeReasonOnSelectAll = false;
            if (this.disputeReason.length === this.dropdownSettings.disputeReasonSelectedItem.length) {
                this.disputeReasonOnSelectAll = true;
            }
        }
        if (this.dropdownSettings.typeIndex === +indexValue) {
            if (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0) {
                var selectedIds_2 = this.dropdownSettings.typeSelectedItems.map(function (index) { return index.id; });
                this.dropdownSettings.subTypeDropdownList = [];
                this.dropdownSettings.subTypeSelectedItems = [];
                this.ticketTypes.filter(function (item) { return selectedIds_2.some(function (index) { return index === item.id; }); }).forEach(function (type) {
                    if (type.value.trim().includes('FLP360')) {
                        type.subTypes.forEach(function (subType) {
                            var subTypeName = subType.name.trim() + '(' + type.value.trim() + ')';
                            _this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subTypeName });
                            _this.ticketTypeOnSelectAll = false;
                        });
                    }
                    else {
                        type.subTypes.forEach(function (subType) {
                            _this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subType.name.trim() });
                            _this.ticketTypeOnSelectAll = false;
                        });
                    }
                    if (type.value === TicketType.Order) {
                        _this.getDisputeReasons();
                        _this.dropdownSettings.disputeReasonSelectedItem = JSON.parse(JSON.stringify(_this.dropdownSettings.disputeReasonDropdownList));
                    }
                    else {
                        _this.dropdownSettings.disputeReasonDropdownList = [];
                        _this.dropdownSettings.disputeReasonSelectedItem = [];
                    }
                });
                if (this.ticketTypes.length === this.dropdownSettings.typeSelectedItems.length) {
                    this.ticketTypeOnSelectAll = true;
                }
                else {
                    this.ticketTypeOnSelectAll = false;
                }
            }
        }
        if (this.dropdownSettings.statusIndex === +indexValue) {
            this.bulkAssignStatus = this.dropdownSettings.statusSelectedItems;
            this.bulkAssignStatus = this.bulkAssignStatus.filter(function (item) { return item.id !== Status.Closed; });
        }
    };
    MyTeamTicketsComponent.prototype.onItemDeSelect = function (item, indexValue) {
        var _this = this;
        if (this.dropdownSettings.subTypeIndex === +indexValue) {
            this.subTypesSort();
        }
        if (this.dropdownSettings.typeIndex === +indexValue) {
            if (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0) {
                var selectedIds_3 = this.dropdownSettings.typeSelectedItems.map(function (index) { return index.id; });
                this.dropdownSettings.subTypeDropdownList = [];
                this.dropdownSettings.subTypeSelectedItems = [];
                this.ticketTypes.filter(function (item) { return selectedIds_3.some(function (index) { return index === item.id; }); }).forEach(function (type) {
                    _this.subTypesSort();
                    if (type.value.trim().includes('FLP360')) {
                        type.subTypes.forEach(function (subType) {
                            var subTypeName = subType.name.trim() + '(' + type.value.trim() + ')';
                            _this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subTypeName });
                            _this.ticketTypeOnSelectAll = false;
                            _this.ticketTypesSort();
                        });
                    }
                    else {
                        type.subTypes.forEach(function (subType) {
                            _this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subType.name.trim() });
                            _this.ticketTypeOnSelectAll = false;
                            _this.ticketTypesSort();
                        });
                    }
                    if (type.value === TicketType.Order) {
                        _this.getDisputeReasons();
                        _this.dropdownSettings.disputeReasonSelectedItem = JSON.parse(JSON.stringify(_this.dropdownSettings.disputeReasonDropdownList));
                        _this.disputeReasonOnSelectAll = false;
                    }
                    else {
                        _this.dropdownSettings.disputeReasonDropdownList = [];
                        _this.dropdownSettings.disputeReasonSelectedItem = [];
                        _this.ticketTypeOnSelectAll = false;
                    }
                });
            }
            else if (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length === 0 && this.isDiputeTicketSearch) {
                this.dropdownSettings.typeSelectedItems = this.dropdownSettings.typeDropdownList.filter(function (item) { return item.itemName.includes(TicketType.Order); });
            }
            else {
                this.dropdownSettings.subTypeDropdownList = [];
                this.dropdownSettings.subTypeSelectedItems = [];
                this.dropdownSettings.disputeReasonDropdownList = [];
                this.dropdownSettings.disputeReasonSelectedItem = [];
            }
        }
        if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = false;
            if (this.showAllTickets) {
                this.dropdownSettings.statusSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.statusDropdownList));
            }
            else if (this.dropdownSettings.statusSelectedItems && this.dropdownSettings.statusSelectedItems.length === 0) {
                this.dropdownSettings.statusSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.statusDropdownList)); //    this.dropdownSettings.statusSelectedItems = this.dropdownSettings.statusDropdownList;
            }
        }
        else if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = false;
        }
        else if (this.dropdownSettings.sourceIndex === +indexValue) {
            this.sourceOnSelectAll = false;
        }
        else if (this.dropdownSettings.departmentIndex === +indexValue) {
            this.departmentOnSelectAll = false;
        }
        else if (this.dropdownSettings.priorityIndex === +indexValue) {
            this.priorityOnSelectAll = false;
        }
        else if (this.dropdownSettings.assignedToIndex === +indexValue) {
            this.assignToOnSelectAll = false;
            this.unAssinged = false;
            if (this.dropdownSettings.assignedToSelectedItems.length === 0) {
                this.unAssinged = true;
            }
        }
        else if (this.dropdownSettings.subTypeIndex === +indexValue) {
            this.subTypeOnSelectAll = false;
            this.subTypesSort();
        }
        else if (this.dropdownSettings.createdByIndex === +indexValue) {
            this.createdByOnSelectAll = false;
            this.unAssinged = false;
            if (this.dropdownSettings.createdBySelectedItems.length === 0) {
                this.unAssinged = true;
            }
        }
        else if (this.dropdownSettings.disputeReasonIndex === +indexValue) {
            this.disputeReasonOnSelectAll = false;
        }
    };
    MyTeamTicketsComponent.prototype.onSelectAll = function (items, indexValue) {
        var _this = this;
        if (this.dropdownSettings.typeIndex === +indexValue) {
            this.dropdownSettings.subTypeDropdownList = [];
            this.dropdownSettings.subTypeSelectedItems = [];
            this.ticketTypes.forEach(function (type) {
                if (type.value.trim().includes('FLP360')) {
                    type.subTypes.forEach(function (subType) {
                        var subTypeName = subType.name.trim() + '(' + type.value.trim() + ')';
                        _this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subTypeName });
                    });
                }
                else {
                    type.subTypes.forEach(function (subType) {
                        _this.dropdownSettings.subTypeDropdownList.push({ id: subType.id, itemName: subType.name.trim() });
                    });
                }
                if (type.value === TicketType.Order) {
                    _this.getDisputeReasons();
                    _this.dropdownSettings.disputeReasonSelectedItem = JSON.parse(JSON.stringify(_this.dropdownSettings.disputeReasonDropdownList));
                    _this.disputeReasonOnSelectAll = true;
                }
                else {
                    _this.dropdownSettings.disputeReasonDropdownList = [];
                    _this.dropdownSettings.disputeReasonSelectedItem = [];
                }
            });
            this.ticketTypeOnSelectAll = true;
        }
        else if (this.dropdownSettings.departmentIndex === +indexValue) {
            this.departmentOnSelectAll = true;
        }
        else if (this.dropdownSettings.assignedToIndex === +indexValue) {
            this.assignToOnSelectAll = true;
            this.unAssinged = true;
        }
        else if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = true;
        }
        else if (this.dropdownSettings.subTypeIndex === +indexValue) {
            this.subTypeOnSelectAll = true;
        }
        else if (this.dropdownSettings.sourceIndex === +indexValue) {
            this.sourceOnSelectAll = true;
        }
        else if (this.dropdownSettings.priorityIndex === +indexValue) {
            this.priorityOnSelectAll = true;
        }
        else if (this.dropdownSettings.createdByIndex === +indexValue) {
            this.createdByOnSelectAll = true;
            this.unAssinged = true;
        }
        else if (this.dropdownSettings.disputeReasonIndex === +indexValue) {
            this.disputeReasonOnSelectAll = true;
        }
        if (this.dropdownSettings.departmentIndex === +indexValue) {
            this.bulkAssignDepts = JSON.parse(JSON.stringify(this.dropdownSettings.departmentSelectedItems));
            this.getAssignedUsersByDepartments(this.dropdownSettings.departmentSelectedItems.map(function (item) { return item.id; }));
        }
        if (this.dropdownSettings.statusIndex === +indexValue) {
            this.bulkAssignStatus = this.dropdownSettings.statusSelectedItems;
            this.bulkAssignStatus = this.bulkAssignStatus.filter(function (item) { return item.id !== Status.Closed; });
        }
    };
    MyTeamTicketsComponent.prototype.onDeSelectAll = function (items, indexValue) {
        if (this.dropdownSettings.typeIndex === +indexValue) {
            if (this.isDiputeTicketSearch) {
                this.dropdownSettings.typeSelectedItems = this.dropdownSettings.typeDropdownList.filter(function (item) { return item.itemName.includes(TicketType.Order); });
            }
            else {
                this.dropdownSettings.subTypeDropdownList = [];
                this.dropdownSettings.subTypeSelectedItems = [];
                this.dropdownSettings.disputeReasonDropdownList = [];
                this.dropdownSettings.disputeReasonSelectedItem = [];
            }
            this.dropdownSettings.subTypeDropdownList = [];
            this.dropdownSettings.subTypeSelectedItems = [];
            this.ticketTypeOnSelectAll = false;
        }
        else if (this.dropdownSettings.departmentIndex === +indexValue) {
            this.departmentOnSelectAll = false;
            this.bulkTicketAssignees = [];
        }
        else if (this.dropdownSettings.assignedToIndex === +indexValue) {
            this.assignToOnSelectAll = false;
            if (this.dropdownSettings.assignedToSelectedItems.length === 0) {
                this.unAssinged = true;
            }
        }
        else if (this.dropdownSettings.statusIndex === +indexValue) {
            this.statusOnSelectAll = false;
        }
        else if (this.dropdownSettings.subTypeIndex === +indexValue) {
            this.subTypeOnSelectAll = false;
        }
        else if (this.dropdownSettings.sourceIndex === +indexValue) {
            this.sourceOnSelectAll = false;
        }
        else if (this.dropdownSettings.priorityIndex === +indexValue) {
            this.priorityOnSelectAll = false;
        }
        else if (this.dropdownSettings.createdByIndex === +indexValue) {
            this.createdByOnSelectAll = false;
            if (this.dropdownSettings.createdBySelectedItems.length === 0) {
                this.unAssinged = true;
            }
        }
        else if (this.dropdownSettings.disputeReasonIndex === +indexValue) {
            this.disputeReasonOnSelectAll = false;
        }
    };
    MyTeamTicketsComponent.prototype.showAllTicketsCheckBox = function (event) {
        this.dropdownSettings.statusSelectedItems = [];
        if (event.target.checked) {
            this.showAllTickets = true;
            this.dropdownSettings.statusSelectedItems = JSON.parse(JSON.stringify(this.dropdownSettings.statusDropdownList));
        }
        else {
            this.showAllTickets = false;
            this.dropdownSettings.statusSelectedItems = this.dropdownSettings.statusDropdownList.filter(function (item) { return item.id === Status.InProgress; });
        }
        this.bulkAssignStatus = this.dropdownSettings.statusSelectedItems;
        this.bulkAssignStatus = this.bulkAssignStatus.filter(function (item) { return item.id !== Status.Closed; });
    };
    MyTeamTicketsComponent.prototype.ShowTicketAndDepatrmentBycountry = function (countryId) {
        this.countryId = countryId;
        this.dropdownSettings.typeDropdownList = [];
        this.dropdownSettings.subTypeDropdownList = [];
        this.dropdownSettings.subTypeSelectedItems = [];
        this.dropdownSettings.typeSelectedItems = [];
        this.departments = [];
        this.dropdownSettings.departmentDropdownList = [];
        this.dropdownSettings.departmentSelectedItems = [];
        this.users = [];
        this.dropdownSettings.assignedToDropdownList = [];
        this.dropdownSettings.assignedToSelectedItems = [];
        this.dropdownSettings.createdByDropdownList = [];
        this.dropdownSettings.createdBySelectedItems = [];
        this.disputeReason = [];
        this.dropdownSettings.disputeReasonDropdownList = [];
        this.dropdownSettings.disputeReasonSelectedItem = [];
        this.getTicketTypesAndSubTypes();
        this.getDepartments();
        // this.getDisputeReasons();
    };
    /*
    Build form for bulk assign
    */
    MyTeamTicketsComponent.prototype.buildForm = function () {
        this.unAssinged = true;
        this.ticketAssignForm = this._formbuilder.group({
            departmentId: ['', Validators.required],
            assignToId: ['', Validators.required],
            statusId: ['']
        });
    };
    /*
    Build form for bulk spam
    */
    MyTeamTicketsComponent.prototype.buildSpamForm = function () {
        this.ticketSpamOrUnspamForm = this._formbuilder.group({
            ticketId: ['', Validators.required]
        });
    };
    /*
    Submit form for bulk assign
    */
    MyTeamTicketsComponent.prototype.submitForm = function (ticketAssingForm) {
        var _this = this;
        this.isSubmitted = true;
        var numOfTickets = this.selectedTickets.length;
        if (this.ticketAssignForm.valid) {
            this.isSubmitted = false;
            if (!this.selectedTickets || this.selectedTickets.length === 0) {
                this.isFormInvalid = true;
                return;
            }
            else {
                var assignee_1 = this.bulkTicketAssignees.find(function (assigne) { return assigne.id === +ticketAssingForm.assignToId; });
                var bulkTickets_1 = new Array();
                var assignedToEmailId_1 = '';
                if (this.bulkTicketAssignees && this.bulkTicketAssignees.length > 0) {
                    var assignedToUser = this.bulkTicketAssignees.find(function (item) { return item.id === +ticketAssingForm.assignToId; });
                    if (assignedToUser) {
                        assignedToEmailId_1 = assignedToUser.email;
                    }
                }
                this.selectedTickets.forEach(function (ticket) { return bulkTickets_1.push({
                    id: ticket.id,
                    ticketNumber: ticket.ticketNumber,
                    modifiedBy: _this.userInfo.userId,
                    agentEmail: _this.userInfo.email,
                    agentName: _this.userInfo.firstName + ' ' + _this.userInfo.lastName,
                    assignedToEmail: assignedToEmailId_1,
                    userId: ticketAssingForm.assignToId
                }); });
                this._customerservice.assignBulkTickets(bulkTickets_1).subscribe(function (response) {
                    if (response) {
                        _this._commonService.createNotification('', numOfTickets + 'Ticket(s) assigned to ' + assignee_1.name + ' successfully', NotificationType.SUCCESS);
                        _this.isBulkAssignSearch = true;
                        if (_this.selectAll) {
                            _this.pageNumber = _this.pageNumber - 1;
                        }
                        _this.selectAll = false;
                        _this.getTicketsSearch();
                    }
                    else {
                        _this._commonService.createNotification('', 'Ticket(s) assignment failed', NotificationType.ERROR);
                    }
                });
            }
        }
        else {
            this.isSubmitted = true;
            if (!this.selectedTickets || this.selectedTickets.length === 0) {
                this.isFormInvalid = true;
                return;
            }
        }
    };
    MyTeamTicketsComponent.prototype.getOperatingCountries = function () {
        var _this = this;
        if (this.operatingCountries) {
            var countryInfo = this.operatingCountries.find(function (country) { return country.id === _this.countryId; });
            if (countryInfo) {
                this.operatingCountries.splice(this.operatingCountries.indexOf(countryInfo), 1);
                this.operatingCountries.splice(0, 0, countryInfo);
            }
        }
    };
    MyTeamTicketsComponent.prototype.getAllowedCountries = function () {
        var countryIds = [];
        if (!this.userInfo.hasSystemRole) {
            if (this.userInfo.allowedOperatingCountries) {
                countryIds = this.userInfo.allowedOperatingCountries.split(',').map(function (i) { return +i; });
                if (countryIds.includes(OperatingCountryEnums.USA)) {
                    return OperatingCountryEnums.USA;
                }
                return countryIds[0];
            }
        }
        return OperatingCountryEnums.USA;
    };
    MyTeamTicketsComponent.prototype.getBulkAssignTickets = function () {
        var _this = this;
        if (this.bulkAssignReq.statusId && this.bulkAssignReq.statusId.length === 1 && this.bulkAssignReq.statusId[0].toString() === '') {
            var statusList = this.bulkAssignStatus;
            statusList = statusList.map(function (item) { return item.id; });
            this.bulkAssignReq.statusId = statusList;
        }
        if (this.bulkAssignReq.departmentId && this.bulkAssignReq.departmentId.length === 1 && this.bulkAssignReq.departmentId[0].toString() === '') {
            var deptsList = this.dropdownSettings.departmentSelectedItems;
            deptsList = deptsList.map(function (item) { return item.id; });
            this.bulkAssignReq.departmentId = deptsList;
        }
        this._customerservice.SearchTicketsOnPagination(null, (this.dropdownSettings.assignedToSelectedItems && this.dropdownSettings.assignedToSelectedItems.length > 0 ? this.dropdownSettings.assignedToSelectedItems.map(function (item) { return item.id; }) : []), this.ticketSearchModel.ticketNumber, (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0 ? this.dropdownSettings.typeSelectedItems.map(function (item) { return item.id; }) : []), (this.dropdownSettings.subTypeSelectedItems && this.dropdownSettings.subTypeSelectedItems.length > 0 ? this.dropdownSettings.subTypeSelectedItems.map(function (item) { return item.id; }) : []), (this.dropdownSettings.sourceSelectedItems && this.dropdownSettings.sourceSelectedItems.length > 0 ? this.dropdownSettings.sourceSelectedItems.map(function (item) { return item.id; }) : []), (this.bulkAssignReq.departmentId), (this.bulkAssignReq.statusId), (this.dropdownSettings.prioritySelectedItems && this.dropdownSettings.prioritySelectedItems.length > 0 ? this.dropdownSettings.prioritySelectedItems.map(function (item) { return item.id; }) : []), this.bulkAssignReq.pageNumber, this.bulkAssignReq.pageSize, this.sortColumn, this.sort, null, this.disputeSearch, (this.dropdownSettings.createdBySelectedItems && this.dropdownSettings.createdBySelectedItems.length > 0 ? this.dropdownSettings.createdBySelectedItems.map(function (item) { return item.id; }) : []), (this.dropdownSettings.disputeReasonSelectedItem && this.dropdownSettings.disputeReasonSelectedItem.length > 0 ? this.dropdownSettings.disputeReasonSelectedItem.map(function (item) { return item.id; }) : [])).subscribe(function (response) {
            if (response) {
                _this.pageCount = response['totalCount'];
                _this.myTickets = response['content'];
                if (_this.myTickets && _this.myTickets.length) {
                    _this.myTickets.forEach(function (x) {
                        if (x.dueDate) {
                            x.dueDate = moment.utc(x.dueDate)
                                .utcOffset(0).format('DD-MMM-YYYY');
                        }
                        if (x.createdDate) {
                            x.createdDate = moment.utc(x.createdDate)
                                .utcOffset(0).format('DD-MMM-YYYY');
                        }
                        if (x.modifiedDate) {
                            x.modifiedDate = moment.utc(x.modifiedDate)
                                .utcOffset(0).format('DD-MMM-YYYY');
                        }
                    });
                }
            }
            else {
                _this.pageCount = 0;
                _this.myTickets = [];
            }
            if (_this.selectedTickets) {
                _this.myTickets.forEach(function (ticket) {
                    if (_this.selectedTickets.find(function (item) { return item.id === ticket.id; })) {
                        ticket.isSelected = true;
                    }
                });
            }
        });
    };
    /*
    Submit form for bulk assign
    */
    MyTeamTicketsComponent.prototype.onDeptChange = function () {
        this.ticketAssignForm.controls['assignToId'].setValue('');
        this.onChange();
    };
    MyTeamTicketsComponent.prototype.onChange = function () {
        var _this = this;
        this.selectAll = false;
        var deptId = this.ticketAssignForm.controls['departmentId'].value;
        var statusId = this.ticketAssignForm.controls['statusId'].value;
        if (this.dropdownSettings.statusSelectedItems && this.dropdownSettings.statusSelectedItems.length === 1 && this.dropdownSettings.statusSelectedItems[0].id === Status.Closed
            && deptId) {
            this.myTickets = [];
            this.pageCount = 0;
            return;
        }
        this.isBulkAssignSearch = true;
        this.myTickets.forEach(function (ticket) { return ticket.isSelected = false; });
        this.selectedTickets = [];
        this.bulkTicketAssignees = [];
        if (!deptId && !statusId) {
            this.getTicketsSearch();
            return;
        }
        this.bulkAssignReq = new PaginationReq;
        this.bulkAssignReq.pageNumber = 1;
        this.bulkAssignReq.sortColumn = 'TICKET_NUMBER';
        this.bulkAssignReq.departmentId = [];
        this.bulkAssignReq.departmentId.push(deptId);
        this.bulkAssignReq.statusId = [];
        this.bulkAssignReq.statusId.push(statusId);
        this.getBulkAssignTickets();
        this.getAllTicketOnFilter();
        if (deptId) {
            this._customerservice.getAssignedUsersByDepartments(+deptId).subscribe(function (response) {
                if (response) {
                    _this.bulkTicketAssignees = response;
                }
            });
        }
    };
    /*
   on change of check box in tickets grid
   */
    MyTeamTicketsComponent.prototype.onTicketSelect = function (event, myTickets) {
        this.isFormInvalid = false;
        if (event.target.checked) {
            if (myTickets.length) {
                for (var _i = 0, myTickets_1 = myTickets; _i < myTickets_1.length; _i++) {
                    var ticket = myTickets_1[_i];
                    if (!ticket.isSelected) {
                        ticket.isSelected = true;
                        this.ticketAssignForm.controls['departmentId'].setValue(ticket.id);
                        this.ticketSpamOrUnspamForm.controls['ticketId'].setValue(ticket.id);
                        this.selectedTickets.push({ id: ticket.id, ticketNumber: ticket.ticketNumber });
                    }
                }
                this.selectAll = this.myTickets.every(function (ticket) { return ticket.isSelected === true; });
            }
        }
        else {
            if (myTickets.length) {
                for (var _a = 0, myTickets_2 = myTickets; _a < myTickets_2.length; _a++) {
                    var ticket = myTickets_2[_a];
                    ticket.isSelected = false;
                    this.selectedTickets.splice(this.selectedTickets.map(function (ticket) { return ticket.id; }).indexOf(ticket.id), 1);
                }
                this.selectAll = this.myTickets.every(function (ticket) { return ticket.isSelected === true; });
            }
        }
    };
    /*
    on change of check box for select all
    */
    MyTeamTicketsComponent.prototype.onSelectAllChange = function () {
        var _this = this;
        if (this.selectAll) {
            this.selectedTickets = [];
            this.ticketsOnSelectAll.forEach(function (ticket) {
                _this.selectedTickets.push({ id: ticket.id, ticketNumber: ticket.ticketNumber });
            });
            this.myTickets.forEach(function (ticket) {
                ticket.isSelected = true;
            });
        }
        else {
            this.selectedTickets = [];
            this.myTickets.forEach(function (ticket) {
                ticket.isSelected = false;
            });
        }
    };
    MyTeamTicketsComponent.prototype.getAllTicketOnFilter = function () {
        var _this = this;
        this._customerservice.getAllTickets(null, (this.dropdownSettings.assignedToSelectedItems && this.dropdownSettings.assignedToSelectedItems.length > 0 ? this.dropdownSettings.assignedToSelectedItems.map(function (item) { return item.id; }) : []), this.ticketSearchModel.ticketNumber, (this.dropdownSettings.typeSelectedItems && this.dropdownSettings.typeSelectedItems.length > 0 ? this.dropdownSettings.typeSelectedItems.map(function (item) { return item.id; }) : []), (this.dropdownSettings.subTypeSelectedItems && this.dropdownSettings.subTypeSelectedItems.length > 0 ? this.dropdownSettings.subTypeSelectedItems.map(function (item) { return item.id; }) : []), (this.dropdownSettings.sourceSelectedItems && this.dropdownSettings.sourceSelectedItems.length > 0 ? this.dropdownSettings.sourceSelectedItems.map(function (item) { return item.id; }) : []), (this.bulkAssignReq.departmentId), (this.bulkAssignReq.statusId), (this.dropdownSettings.prioritySelectedItems && this.dropdownSettings.prioritySelectedItems.length > 0 ? this.dropdownSettings.prioritySelectedItems.map(function (item) { return item.id; }) : []), this.bulkAssignReq.pageNumber, this.bulkAssignReq.pageSize, this.sortColumn, this.sort, (this.dropdownSettings.disputeReasonSelectedItem && this.dropdownSettings.disputeReasonSelectedItem.length > 0 ? this.dropdownSettings.disputeReasonSelectedItem.map(function (item) { return item.id; }) : [])).subscribe(function (response) {
            if (response) {
                _this.ticketsOnSelectAll = response['content'];
            }
            else {
                _this.ticketsOnSelectAll = [];
            }
        });
    };
    MyTeamTicketsComponent.prototype.getAssignToUsersByDepartments = function (departmentIds) {
        var _this = this;
        if (departmentIds && departmentIds.length > 0) {
            this._customerservice.getBulkAssignedUsersByDepartmentIds(departmentIds).subscribe(function (response) {
                if (response) {
                    _this.bulkTicketAssignees = response;
                }
            });
        }
        else {
            this.bulkTicketAssignees = [];
        }
    };
    MyTeamTicketsComponent.prototype.selectTicketAsSpamOrUnspam = function (ticketSpamOrUnspamForm) {
        if (this.ticketSpamOrUnspamForm.valid && ticketSpamOrUnspamForm) {
            if (!this.selectedTickets || this.selectedTickets.length === 0) {
                this.isFormInvalid = true;
                return;
            }
            else {
                this.openSpamOrUnspamTicketConfirmationPopup();
            }
        }
        else {
            this.isFormInvalid = true;
        }
    };
    MyTeamTicketsComponent.prototype.closeSpamOrUnpsamTicketConfirmationPopup = function () {
        this.spamOrUnspamTicketConfirmation.close();
    };
    MyTeamTicketsComponent.prototype.openSpamOrUnspamTicketConfirmationPopup = function () {
        this.spamOrUnspamTicketConfirmation.open();
    };
    MyTeamTicketsComponent.prototype.unselectTicketsWhenSpamOrUnspamFailed = function () {
        var _this = this;
        this.selectedTickets.forEach(function (selectedTicket) {
            _this.myTickets.forEach(function (myTicket) {
                if (selectedTicket.id === myTicket.id) {
                    myTicket.isSelected = false;
                }
            });
        });
    };
    /* To spam or unspam the selected tickets */
    MyTeamTicketsComponent.prototype.spamorUnspamSelectedTickets = function () {
        var _this = this;
        var listOfTicketsToBeSpamed = [];
        var spamOrUnspamReason;
        var isSpam;
        if (this.dropdownSettings.statusSelectedItems.length === 1 && this.dropdownSettings.statusSelectedItems[0].id === Status.Closed) {
            isSpam = false;
            spamOrUnspamReason = this._translatePipe.get('validation-message.Ticket is marked as unspam');
        }
        else {
            isSpam = true;
            spamOrUnspamReason = this._translatePipe.get('validation-message.Ticket is marked as spam');
        }
        this.selectedTickets.forEach(function (ticket) {
            listOfTicketsToBeSpamed.push({ id: ticket.id, ticketNumber: ticket.ticketNumber, updatedBy: _this.userInfo.userId, closeOtherReason: spamOrUnspamReason.value });
        });
        this._customerservice.markATicketorAllTicketsAsSpamOrUnpsam(listOfTicketsToBeSpamed, isSpam).subscribe(function (response) {
            if (response) {
                var success = void 0;
                if (isSpam) {
                    success = _this._translatePipe.get('success-message.Ticket(s) marked as spam and closed successfully');
                }
                else {
                    success = _this._translatePipe.get('success-message.Ticket(s) marked as not spam successfully');
                }
                _this._commonService.createNotification('', success.value, NotificationType.SUCCESS);
                _this.isAllSelectedTicketsSpamedOrUnspamed = true;
                if (_this.selectAll) {
                    _this.pageNumber = _this.pageNumber - 1;
                }
                _this.selectAll = false;
                _this.getTicketsSearch();
            }
            else {
                var failed = void 0;
                if (isSpam) {
                    failed = _this._translatePipe.get('error-message.Tickets couldn\'t be marked as spam');
                }
                else {
                    failed = _this._translatePipe.get('error-message.Tickets couldn\'t be marked as unspam');
                }
                _this._commonService.createNotification('', failed.value, NotificationType.ERROR);
                _this.unselectTicketsWhenSpamOrUnspamFailed();
                _this.isAllSelectedTicketsSpamedOrUnspamed = true;
                _this.resetTicketSpamOrUnspamForm();
            }
        }, function (error) {
            var unknown = _this._translatePipe.get('validation-message.Unknown Error');
            _this.message = (error != null && error[0] != null) ? error[0].field + ' : ' + error[0].message : unknown.value;
            _this._commonService.createNotification('', _this.message, NotificationType.ERROR);
            _this.unselectTicketsWhenSpamOrUnspamFailed();
            _this.isAllSelectedTicketsSpamedOrUnspamed = true;
            _this.resetTicketSpamOrUnspamForm();
        });
        this.spamOrUnspamTicketConfirmation.close();
    };
    MyTeamTicketsComponent.prototype.setFocusToTextBox = function () {
        setTimeout(function () {
            var element = document.getElementById('ticketNumber');
            var email = document.getElementById('email');
            if (element.value) {
                element.focus();
            }
            else if (email.value) {
                email.focus();
            }
            else {
                element.focus();
            }
        }, 1000);
    };
    MyTeamTicketsComponent.prototype.OnTabEventRecentlyViewed = function () {
        var element = document.getElementById('ticketNumber');
        if (element) {
            element.focus();
        }
        event.preventDefault();
    };
    MyTeamTicketsComponent.prototype.OnTabSearchFocus = function () {
        var element = document.getElementById('searchbutton');
        if (element) {
            element.focus();
        }
        event.preventDefault();
    };
    MyTeamTicketsComponent.prototype.intializeMultiselectDropdowns = function () {
        this.dropdownSettings.sourceDropdownList = [];
        this.dropdownSettings.sourceSelectedItems = [];
        this.dropdownSettings.typeDropdownList = [];
        this.dropdownSettings.typeSelectedItems = [];
        this.dropdownSettings.subTypeDropdownList = [];
        this.dropdownSettings.subTypeSelectedItems = [];
        this.dropdownSettings.statusDropdownList = [];
        this.dropdownSettings.statusSelectedItems = [];
        this.dropdownSettings.departmentDropdownList = [];
        this.dropdownSettings.departmentSelectedItems = [];
        this.dropdownSettings.priorityDropdownList = [];
        this.dropdownSettings.prioritySelectedItems = [];
        this.dropdownSettings.disputeReasonDropdownList = [];
        this.dropdownSettings.disputeReasonSelectedItem = [];
        this.dropdownSettings.settings = {
            text: 'Select..',
            selectAllText: 'Select All',
            unSelectAllText: 'Select All',
            classes: 'myclass custom-class',
            badgeShowLimit: 1,
        };
    };
    MyTeamTicketsComponent.prototype.clearFields = function () {
        this.dropdownSettings.settings = __assign({}, this.dropdownSettings.settings, { disabled: false });
        this.chRef.detectChanges();
        this.overDueDisable = false;
        this.setFocusToTextBox();
        this.getTicketTypesAndSubTypes();
        this.intializeMultiselectDropdowns();
        this.getSourceTypes();
        this.getTicketStatus();
        this.getDisputeReasons();
        this.showAllTickets = true;
        this.deleteModal = new DeleteModal(this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this));
        this.deleteModal.viewActionButtons = false;
        this.getDepartments();
        this.getTicketPriorities();
        this.ticketSearchModel.ticketNumber = '';
        this.ticketSearchModel.email = '';
        this.ticketTypeOnSelectAll = true;
        this.statusOnSelectAll = true;
        this.sourceOnSelectAll = true;
        this.subTypeOnSelectAll = true;
        this.departmentOnSelectAll = true;
        this.priorityOnSelectAll = true;
        this.selectedTickets = [];
        this.createdByOnSelectAll = true;
        this.disputeReasonOnSelectAll = true;
    };
    MyTeamTicketsComponent.prototype.goToViewTicket = function (id, ticketNumber) {
        if (this.isTicketView) {
            var ticketTab = new TicketTabInfo();
            ticketTab.isNewTicket = false;
            ticketTab.ticketID = id;
            ticketTab.title = 'View Ticket - ' + ticketNumber;
            ticketTab.viewTicket = true;
            ticketTab.isTeamTicket = true;
            this.messageService.setCustomerServiceUserTabContent(ticketTab);
        }
        else {
            this.displayAlertbox();
        }
    };
    MyTeamTicketsComponent.prototype.getDisputeReasons = function () {
        var _this = this;
        this.dropdownSettings.disputeReasonDropdownList = [];
        this.dropdownSettings.disputeReasonSelectedItem = [];
        this._customerservice.getDisputeReasons().subscribe(function (response) {
            if (response) {
                _this.disputeReason = response;
                _this.disputeReason.forEach(function (item) {
                    _this.dropdownSettings.disputeReasonDropdownList.push({ id: item.id, itemName: item.value.trim() });
                });
                _this.dropdownSettings.disputeReasonDropdownList.sort(function (item1, item2) {
                    var tickettype1 = item1.itemName.toLowerCase(), tickettype2 = item2.itemName.toLowerCase();
                    if (tickettype1 < tickettype2) {
                        return -1;
                    }
                    if (tickettype1 > tickettype2) {
                        return 1;
                    }
                    return 0;
                });
                // this.dropdownSettings.disputeReasonSelectedItem = JSON.parse(JSON.stringify(this.dropdownSettings.disputeReasonDropdownList));
            }
            else {
                _this.disputeReason = [];
                _this.dropdownSettings.disputeReasonDropdownList = [];
                _this.dropdownSettings.disputeReasonSelectedItem = [];
            }
        });
    };
    return MyTeamTicketsComponent;
}());
export { MyTeamTicketsComponent };



// WEBPACK FOOTER //
// ./src/app/customerservice/components/my-team-tickets.component.ts.pre-build-optimizer.js